/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import { parseBoolean } from '@jalik/form-parser'
import FormField from '../../../../client/js/components/form/fields/FormField'
import { Select, SelectProps } from '@mantine/core'

export type EnabledFieldProps = Omit<SelectProps, 'data'>

function EnabledField (props: EnabledFieldProps) {
  const { name = 'enabled', ...others } = props
  const intl = useIntl()
  return (
    <FormField
      label={intl.formatMessage({
        id: 'status',
        defaultMessage: 'État'
      })}
      {...others}
      parser={parseBoolean}
      name={name}
      render={Select}
      data={[
        {
          label: intl.formatMessage({
            id: 'disabled',
            defaultMessage: 'Désactivé'
          }),
          value: 'false'
        },
        {
          label: intl.formatMessage({
            id: 'enabled',
            defaultMessage: 'Activé'
          }),
          value: 'true'
        }
      ]}
    />
  )
}

export default EnabledField
